/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartGaugeOdometer = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 3c5.515 0 10 4.441 10 9.9 0 3.141-1.464 6.027-4.016 7.92l-.243.18H6.26l-.243-.18C3.465 18.927 2 16.041 2 12.9 2 7.442 6.486 3 12 3zm0 2c-4.41 0-8 3.533-8 7.875 0 2.403 1.085 4.62 2.988 6.125h10.025C18.916 17.493 20 15.278 20 12.875 20 8.533 16.412 5 12 5zm3.711 2.933 1.414 1.414-2.414 2.368c.186.39.29.826.29 1.285 0 1.654-1.347 3-3 3s-3-1.346-3-3a3.004 3.004 0 0 1 4.3-2.703zM12.001 12a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartGaugeOdometer as ChartGaugeOdometer };
